var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"newsletter-recipient"}},[(_vm.recipient.id)?_c('div',[_c('h2',[_vm._v("Newsletter Recipient #"+_vm._s(_vm.recipient.id))]),_vm._v(" "),_c('newsletter-nav',{attrs:{"newsletterId":_vm.newsletterId}}),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tr',[_c('td',[_vm._v("\n          Newsletter\n        ")]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{
            name: 'newsletter',
            params: {
              newsletterId: _vm.recipient.newsletter_id
            }
          }}},[_vm._v("\n            #"+_vm._s(_vm.recipient.newsletter_id)+"\n          ")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n          Subscriber\n        ")]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{
            name: 'newsletter_type_subscriber',
            params: {
              newsletterTypeSubscriberId: _vm.recipient.newsletter_type_subscriber_id
            }
          }}},[_vm._v("\n            #"+_vm._s(_vm.recipient.newsletter_type_subscriber_id)+"\n          ")])],1)])])],1):_vm._e(),_vm._v(" "),_c('email-recipient',{ref:"emailRecipient",attrs:{"newsletterId":_vm.newsletterId,"recipientId":_vm.newsletterRecipientId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9cb82dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsletterRecipient.vue
// module id = 1296
// module chunks = 1